export default __webpack_public_path__ + "static/media/8.9f2c4407.jpg";